import { Box, Text, Stack, Group, Badge } from '@mantine/core'

const tendencyColors = {
  mobilizer: 'orange',
  stabilizer: 'blue',
  connector: 'green',
  strategist: 'violet',
}

export function EvolutionTimeline({ evolution = [] }) {
  if (evolution.length === 0) return null

  return (
    <Stack gap={0}>
      {evolution.map((entry, i) => {
        const isLast = i === evolution.length - 1
        const color = tendencyColors[entry.primary_tendency] || 'cyan'

        return (
          <Group key={i} gap="md" wrap="nowrap" align="flex-start">
            {/* Timeline connector */}
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 20,
                flexShrink: 0,
              }}
            >
              <Box
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: `var(--mantine-color-${color}-5)`,
                  boxShadow: `0 0 6px var(--mantine-color-${color}-5)`,
                  flexShrink: 0,
                  marginTop: 4,
                }}
              />
              {!isLast && (
                <Box
                  style={{
                    width: 2,
                    flex: 1,
                    minHeight: 36,
                    background: 'rgba(0, 229, 255, 0.12)',
                  }}
                />
              )}
            </Box>

            {/* Entry content */}
            <Box style={{ paddingBottom: isLast ? 0 : 16 }}>
              <Group gap="sm" wrap="nowrap">
                <Text size="sm" fw={600} c="gray.3">
                  {entry.story_name}
                </Text>
                <Badge size="xs" variant="light" color={color} tt="capitalize">
                  {entry.primary_tendency}
                </Badge>
              </Group>
              <Text size="xs" c="dimmed">
                {entry.session_date && new Date(entry.session_date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </Text>
            </Box>
          </Group>
        )
      })}
    </Stack>
  )
}
